import React from 'react';
import styles from './index.module.less';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import classNames from 'classnames';

export const InfluencersLabelsAlert = ({
  openListData,
  selectItem,
  onCloseClick,
  onSelectClick
}: {
  openListData?: string[];
  selectItem?: string;
  onCloseClick?: () => void;
  onSelectClick?: (value?: string) => void;
}) => {
  return (
    <Modal
      open={openListData?.length > 0}
      onCancel={() => onCloseClick()}
      destroyOnClose={true}
      closeIcon={<CloseOutlined style={{ color: 'var(--app-text-color)' }} />}
      footer={null}
    >
      <div className={styles.content}>
        <div className={styles.alertContainer}>
          {(openListData ?? []).map((item) => {
            return (
              <div
                key={item}
                className={classNames(styles.imgLabelContainer, item === selectItem ? styles.active : '')}
                onClick={() => {
                  if (onSelectClick) {
                    onSelectClick(item === selectItem ? null : item);
                  }
                }}
              >
                <span>{item}</span>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};
